import { render, staticRenderFns } from "./DirectSaleCommission.vue?vue&type=template&id=e570c236&"
import script from "./DirectSaleCommission.vue?vue&type=script&lang=js&"
export * from "./DirectSaleCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports